<template>
  <div class="ruKuZuoyeWarp-body app-container" >
    <!-- 查询条件 -->
    <div ref="searchBox" class="formBox margbot">
      <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData" label-width="90px" size="mini">
        <div class="formItemBox">
        <el-form-item label="时间:">
          <el-date-picker
            v-model="formData.createTime"
            size="mini"
            type="datetime"
            placeholder="请选择"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="一级货主:">
          <el-select v-model="formData.primaryCustomerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
            <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName" :value="item.taxpayerNumber"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级货主:">
          <el-select v-model="formData.customerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
            <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName" :value="item.taxpayerNumber"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="仓位:">
          <el-select v-model="formData.warehouseId" size="mini" placeholder="请选择仓位" filterable clearable>
            <el-option v-for="(item, index) in cangWeiData" :key="index" :label="item.warehouseName" :value="item.warehouseId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="货物类型:">
          <el-select v-model="formData.productType" size="mini" placeholder="请选择货物类型" filterable clearable @change="productTypeChange">
            <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName" :value="item.productType"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产地:">
          <el-select v-model="formData.steelMillName" size="mini" placeholder="请选择产地" filterable clearable @change="steelMillNameChange">
            <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规格:">
          <el-select v-model="formData.specification" size="mini" placeholder="请选择规格" filterable clearable @change="specificationChange">
            <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="材质:">
          <el-select v-model="formData.model" size="mini" placeholder="请选择材质" filterable clearable @change="modelChange">
            <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="件数:">
          <el-select v-model="formData.number" size="mini" placeholder="请选择件数" filterable clearable>
            <el-option v-for="(item, index) in numberOptions" :key="index"  :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车船号:">
          <el-input
            class="ipt"
            v-model="formData.plateNumber"
            placeholder="请输入车船号"
            size="mini"
          ></el-input>
        </el-form-item>
         </div>
        <el-form-item>
          <el-button type="primary" size="mini" @click="chaxun" btnCode="00cP009B001" v-if="btnFlg[0]">查询</el-button>
          <el-button type="primary" size="mini" @click="chongzhi" btnCode="00cP009B002" v-if="btnFlg[1]">重置</el-button>
          <el-button type="primary" size="mini" @click="exportClick" btnCode="00cP009B003" v-if="btnFlg[2]">导出</el-button>
        </el-form-item>
         <el-form-item>
          <div ref="searchBox2" style="margin-top: 5px;margin-bottom:5px;margin-left:10px;">
            <span>
              总吨数:
              <span style="color: red">{{Number(totalAllWeight).toFixed(4)}}</span> &nbsp;吨
            </span>
            <span style="margin-left: 15px">
              总件数:
              <span style="color: red">{{ totalNumber }}</span> &nbsp;件
            </span>
          </div>
         </el-form-item>
      </el-form>

    </div>
    <!-- 表格 -->
    <div :style="{ height: h }">
      <el-table
      height="100%"
      size="mini"
      border
      center
      bordersize="mini"
      ref="tabref1"
      :data="tableData"
      style="width: 100%"
      class="elTab"
      :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
      highlight-current-row
      @row-click="dianjixuanzhong"
      @selection-change="selectGoods"
    >
      <el-table-column fixed type="index" align="center" label="序号" width="60"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" align="center" width="220"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center" width="220"></el-table-column>
      <el-table-column prop="productTypeName" label="货物类型" align="center" ></el-table-column>
      <el-table-column prop="steelMillName" label="产地" align="center" ></el-table-column>
      <el-table-column prop="specification" label="规格" align="center" width="120"></el-table-column>
      <el-table-column prop="model" label="材质" align="center" width="120"></el-table-column>
      <el-table-column prop="warehouseName" label="仓位" align="center"></el-table-column>
      <el-table-column prop="number" label="件数" align="center"></el-table-column>
      <el-table-column prop="allWeight" label="总重量（吨）" width="120" align="center"></el-table-column>
      <el-table-column prop="inAverageWeight" label="入库件重（吨）" width="150" ></el-table-column>
      <el-table-column prop="averageWeight" label="平均件重（吨）" width="150" ></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="stockWeight" label="理重(吨)" align="center"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="stockPoundWeight" label="过磅净重（吨）" width="120" align="center"></el-table-column>
      <el-table-column prop="instockDate" label="入库时间" width="180" ></el-table-column>
      <el-table-column prop="plateNumber" label="车船号" width="120" ></el-table-column>
      <el-table-column prop="shipForecastNo" label="预报编号" width="260" ></el-table-column>
    </el-table>
    </div>
    <div class="pags" style="text-align: right">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="pageInfo.pageNo"
        :page-size="pageInfo.pageSize"
        :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        :total="total"
      ></el-pagination>
    </div>
  </div>

</template>

<script>
import {
  getRelationCustomer,
  getVirtualBalingList
} from '@/api/wms-stock'
import {
  zidianKuwei,
  stockSummaryHistoryList, // 查询
  weightAndPiece
} from '@/api/wms-access'
import DonMessage from '@/utils/message'
import { exportExcel } from '@/utils/fileDown.js'
import { getBtn } from '@/utils/getButton'
export default {
  components: { },
  name: 'yycHistoryKC',
  data () {
    return {
      formData: {
        createTime: this.timeStamp((new Date()).getTime()),
        primaryCustomerTaxId: '',
        customerTaxId: '',
        productType: '',
        steelMillName: '',
        specification: '',
        model: '',
        number: '',
        plateNumber: '',
        warehouseId: ''
      },
      RKData: [],
      cangWeiData: [],
      productTypeData: [],
      steelMillNameData: [],
      specificationData: [],
      modelData: [],
      numberOptions: [{
        value: '',
        label: '全部'
      }, {
        value: '0',
        label: '0'
      }, {
        value: '-1',
        label: '不为0'
      }],
      totalAllWeight: 0,
      totalNumber: 0,
      h: '500px',
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      tableData: [],
      selectListId: [],
      selectList: [],
      btnArr: [
        '00cP009B001',
        '00cP009B002',
        '00cP009B003'
      ],
      btnFlg: [],
      xuanzhongArr: null,
      message: ''
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 168 + 'px'
    this.getRelationCustomerS()
  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/yycHistoryKC')
    this.getVirtualBalingList()

    this.JfgetStockCustomerLists()
    this.zidianKuwei()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.chaxun()
      }
    }
  },
  methods: {
    // 仓位
    zidianKuwei () {
      zidianKuwei().then(res => {
        this.cangWeiData = res
      })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    // 总数
    JfgetStockCustomerWNs () {
      weightAndPiece({
        primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
        customerTaxId: this.formData.customerTaxId,
        productType: this.formData.productType,
        steelMillName: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model,
        number: this.formData.number,
        createTime: this.formData.createTime, // 日期，//必填
        warehouseId: this.formData.warehouseId, // 仓库id,
        plateNumber: this.formData.plateNumber // 车船号，
      })
        .then(res => {
          this.totalAllWeight = res.allWeight
          this.totalNumber = res.allPiece
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    timeStamp: function (value) {
      let date = new Date()
      let Y = date.getFullYear()
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
      let D = date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate()
      let hours = date.getHours()
      let minutes = date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes()
      let seconds = date.getSeconds() < 10 ? ('0' + date.getSeconds()) : date.getSeconds()
      date = Y + '-' + M + '-' + D + ' ' + hours + ':' + minutes + ':' + seconds
      return date
    },
    // 列表查询
    JfgetStockCustomerLists () {
      stockSummaryHistoryList({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
        customerTaxId: this.formData.customerTaxId,
        productType: this.formData.productType,
        steelMillName: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model,
        number: this.formData.number,
        createTime: this.formData.createTime, // 日期，//必填
        warehouseId: this.formData.warehouseId, // 仓库id,
        plateNumber: this.formData.plateNumber // 车船号，
      })
        .then(res => {
          this.tableData = res.list
          this.total = res.total
          this.JfgetStockCustomerWNs()
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    chaxun () {
      this.JfgetStockCustomerLists()
    },
    chongzhi () {
      this.formData = {
        createTime: this.timeStamp((new Date()).getTime())
      }
      this.chaxun()
      this.getVirtualBalingList()
    },
    // 选中
    selectGoods (selection) {
      this.selectListId = []
      this.selectList = selection
      let arry = []
      selection.forEach((item) => {
        arry.push(item.stockCustomerId) // id数组
        arry = Array.from(new Set(arry)) // 去重
      })
      this.selectListId = arry.join(',') // 获取全部货物id
    },
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    },
    // 导出
    exportClick () {
      exportExcel(
        this.global.wmsAccessName + '/shipStock/stockSummaryHistory/export',
        this.formData,
        '历史库存信息表'
      )
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
      })
        .then((res) => {
          this.RKData = res
        })
        .catch((err) => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          this.$message({ message: error.message, type: 'error' })
        })
    },
    // 货物类型下拉框改变事件
    productTypeChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 产地下拉框改变事件
    steelMillNameChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 规格下拉框改变事件
    specificationChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 材质下拉框改变事件
    modelChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.lengthData = []
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    }
  }
}
</script>

<style lang='less' scoped>
.messages{
  font-size:16px;
}
</style>
